<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="m-0">Usuários do Cliente</h5>
      <button v-if="!showForm && usuarios.length < 2" class="btn btn-primary" @click="showForm = true">
        Adicionar <i class="fas fa-plus ms-1"></i>
      </button>
    </div>

    <div v-if="usuarios.length === 0" class="mb-3 text-muted">Nenhum usuário wizard cadastrado para este cliente.</div>

    <div class="table-responsive mb-3" v-else>
      <table class="table">
        <thead>
          <tr>
            <th style="color: #6c757d">Usuário</th>
            <th style="color: #6c757d">Email</th>
            <th style="color: #6c757d">Tipo</th>
            <th style="color: #6c757d">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="u in usuarios" :key="u.id" class="border-bottom">
            <td style="font-weight: 500">{{ u.nome }}</td>
            <td>{{ u.email }}</td>
            <td>
              <span class="badge bg-success text-white px-2 py-1 rounded-pill" style="font-size: 0.8rem">
                {{ u.tipo === 1 ? 'PROPRIETÁRIO' : 'GERENTE' }}
              </span>
            </td>
            <td>
              <button class="btn btn-danger btn-sm" style="border-radius: 4px" @click="confirmDeleteUsuario(u)">
                Excluir
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="usuarios.length >= 2" class="alert alert-warning mb-3">
      <i class="fas fa-exclamation-triangle me-2"></i>
      Limite máximo de 2 usuários por cliente atingido.
    </div>
    <form v-if="showForm" @submit.prevent="onSubmit">
      <div class="mb-3">
        <label>Nome</label>
        <input v-model="v$.usuario.nome.$model" type="text" class="form-control" />
        <div class="input-errors" v-for="(e, index) of v$.usuario.nome.$errors" :key="index">
          <div class="text-danger text-xs">{{ e.$message }}</div>
        </div>
      </div>
      <div class="mb-3">
        <label>Email</label>
        <input v-model="v$.usuario.email.$model" type="email" class="form-control" />
        <div class="input-errors" v-for="(e, index) of v$.usuario.email.$errors" :key="index">
          <div class="text-danger text-xs">{{ e.$message }}</div>
        </div>
      </div>
      <div class="mb-3">
        <label>Senha</label>
        <div class="input-group">
          <input :type="showPassword ? 'text' : 'password'" v-model="v$.usuario.password.$model" class="form-control" />
          <button type="button" class="btn btn-outline-secondary" @click="togglePassword"
            :title="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
            <span v-if="showPassword">🙈</span>
            <span v-else>👁️</span>
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="gerarSenhaAleatoria"
            title="Gerar senha aleatória">
            Gerar
          </button>
        </div>
        <div class="input-errors" v-for="(e, index) of v$.usuario.password.$errors" :key="index">
          <div class="text-danger text-xs">{{ e.$message }}</div>
        </div>
      </div>
      <div class="mb-3">
        <label>Confirmar Senha</label>
        <div class="input-group">
          <input :type="showPassword ? 'text' : 'password'" v-model="v$.usuario.passwordConfirm.$model"
            class="form-control" />
          <button type="button" class="btn btn-outline-secondary" @click="togglePassword"
            :title="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
            <span v-if="showPassword">🙈</span>
            <span v-else>👁️</span>
          </button>
        </div>
        <div class="input-errors" v-for="(e, index) of v$.usuario.passwordConfirm.$errors" :key="index">
          <div class="text-danger text-xs">{{ e.$message }}</div>
        </div>
      </div>
      <div class="mb-3">
        <label>Tipo</label>
        <select v-model="v$.usuario.tipo.$model" class="form-control">
          <option value="1">Proprietário</option>
          <option value="2">Gerente</option>
        </select>
      </div>
      <button type="submit" class="btn btn-primary">Salvar Usuário Wizard</button>
      <button type="button" class="btn btn-secondary ms-2" @click="cancelForm">Cancelar</button>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, helpers, sameAs, minLength, email as emailValidator } from '@vuelidate/validators'
import api from '@/services/api';
import { successToast, errorToast, showConfirm } from '@/utils/alerts';
export default {
  name: 'UsuarioWizardTab',
  props: {
    cliente: { type: Object, required: true }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      usuarios: [],
      showForm: false,
      showPassword: false,
      usuario: {
        nome: '',
        email: '',
        password: '',
        passwordConfirm: '',
        tipo: 1,
        clienteFreemium: { id: this.cliente?.id }
      },
      success: false,
      error: null
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    gerarSenhaAleatoria() {
      const length = 10;
      const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*';
      let password = '';
      for (let i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n));
      }
      this.usuario.password = password;
    },
    async fetchUsuarios() {
      try {
        const res = await api.get('/clientes-freemium/usuarios-clientes/' + this.cliente.id);
        this.usuarios = res.data;
      } catch (e) {
        this.usuarios = [];
      }
    },
    async onSubmit() {
      const isFormValid = await this.v$.$validate();

      if (!isFormValid) {
        return;
      }

      try {
        // Garantir que o cliente seja enviado corretamente
        const usuarioData = {
          ...this.usuario,
          clienteFreemium: { id: this.cliente?.id }
        };
        delete usuarioData.passwordConfirm; // Remover campo que não existe no backend

        await api.post('/clientes/usuarios-wizard-clientes', usuarioData);
        // Mostrar toast de sucesso
        successToast('Usuário Wizard salvo com sucesso!');

        this.error = null;
        this.showForm = false;
        this.usuario = { nome: '', email: '', password: '', tipo: 1, cliente: { id: this.cliente?.id }, passwordConfirm: '' };
        await this.fetchUsuarios();
      } catch (e) {
        const errorMessage = e?.response?.data?.message || 'Erro ao salvar usuário wizard';
        errorToast(errorMessage);
      }
    },
    cancelForm() {
      this.showForm = false;
      this.usuario = { nome: '', email: '', password: '', tipo: 1, cliente: this.cliente, passwordConfirm: '' };
    },

    async confirmDeleteUsuario(usuario) {
      const result = await showConfirm(
        `Tem certeza que deseja excluir o usuário ${usuario.nome}?`,
        'Confirmar exclusão'
      );

      if (result) {
        this.deleteUsuario(usuario.id);
      }
    },

    async deleteUsuario(id) {
      try {
        await api.delete(`/usuarios-wizard/${id}`);
        successToast('Usuário excluído com sucesso!');
        await this.fetchUsuarios();
      } catch (e) {
        const errorMessage = e?.response?.data?.message || 'Erro ao excluir usuário';
        errorToast(errorMessage);
      }
    }
  },
  mounted() {
    if (this.cliente?.id) {
      this.fetchUsuarios();
    }
  },
  watch: {
    'cliente.id': {
      handler(newId) {
        if (newId) {
          this.fetchUsuarios();
        }
      },
      immediate: true
    }
  },
  validations() {
    return {
      usuario: {
        nome: {
          required: helpers.withMessage('Nome é obrigatório.', required)
        },
        email: {
          required: helpers.withMessage('E-mail é obrigatório.', required),
          email: helpers.withMessage('E-mail inválido.', emailValidator)
        },
        password: {
          required: helpers.withMessage('Senha é obrigatória.', required),
          minLength: helpers.withMessage('Senha deve ter pelo menos 6 caracteres.', minLength(6))
        },
        tipo: {
          required: helpers.withMessage('Tipo de usuário é obrigatório.', required)
        },
        passwordConfirm: {
          require: helpers.withMessage('Confirmar senha é obrigatório', required),
          sameAs: helpers.withMessage('As senhas não conferem', sameAs(this.usuario.password))
        },
      }
    };
  },
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
</style>
